import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { PrizeType } from '../enums/PrizeType'
import type { PrizeTranslationEntity } from './PrizeTranslationEntity'
import type { CouponMiniEntity } from '@/features/coupons/domain/entities/CouponMiniEntity'

export class CreateUpdatePrizeEntity {
  type?: PrizeType
  externalId?: string | null
  externalName?: string | null
  coupon?: CouponMiniEntity
  color?: string | null
  image?: FileUploadEntity
  translations?: Array<PrizeTranslationEntity> | null
  weight?: number | null
}
